import { render, staticRenderFns } from "./BaseButtonGroup.vue?vue&type=template&id=4a1768fa&"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports